import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../i18n/LangContext';

const Hero = () => {
	const { t } = useLang();
	return (
		<section id="about" className="min-h-screen flex items-center pt-20 bg-gradient-to-b from-slate-50 to-white">
			<div className="container mx-auto px-6">
				<div className="max-w-4xl mx-auto text-center">
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
					>
						<motion.picture
							className="flex justify-center mb-10"
							initial={{ opacity: 0, scale: 0.85, rotate: 2 }}
							animate={{ opacity: 1, scale: 1, rotate: 0 }}
							transition={{ duration: 0.7, ease: 'easeOut' }}
						>
							<source type="image/webp" media="(max-width: 799px)" srcSet="/img/logo-350.webp" />
							<source type="image/webp" media="(min-width: 800px)" srcSet="/img/logo.webp" />
							<img
								src="/img/logo.jpg"
								className="App-logo w-32 sm:w-40 md:w-52 lg:w-64 xl:w-72 h-auto mx-auto drop-shadow-sm"
								alt="Shop programs studio logo"
								fetchPriority="high"
								decoding="async"
								loading="eager"
							/>
						</motion.picture>
						<h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-[5.5rem] xl:text-[6rem] font-bold text-slate-900 mb-6 md:mb-8 tracking-tight leading-tight">
							{t.hero.headline1} <br className="hidden md:block" />
							<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
								{t.hero.headline2}
							</span>
						</h1>
						<p className="text-lg sm:text-xl md:text-2xl lg:text-[1.4rem] text-slate-600 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
							{t.hero.subheadline}
						</p>
						<div className="flex flex-col sm:flex-row justify-center gap-4">
							<a
								href="#contact"
								className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-all hover:scale-105 shadow-lg shadow-blue-600/20"
							>
								{t.hero.cta_start}
								<ArrowRight className="ml-2" size={20} />
							</a>
							<a
								href="#services"
								className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-slate-700 bg-white border border-slate-200 rounded-full hover:bg-slate-50 transition-all hover:border-slate-300"
							>
								{t.hero.cta_services}
							</a>
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
